(function () {

	'use strict';

	/*global $:true */

	let cologicViewService = {

		initView: function () {

			let that = this;
            that.manageScroll();

			this.setMenueListBinding();
			this.setMenueSlug();
			this.showToTop();
			// this.setBurger();
			this.bindBurger();
			this.bindContactButton();
			this.enableAccordion();
			this.toggleMenue();
			this.slideLoadedSingle();
			this.setMbVideoHeight();
			// this.navigationHandling();
			// this.setYoutubeBox();
            this.checkVideoPlaySetup();
            this.resetAnimationForIos();
			$('.toTopWrapper').click(this.pageToTop);
			$(window).scroll(function () {
                that.runScrollAnimation();
				that.toggleMenue();
				that.showToTop();
			});
            $(window).on('hashchange', function() {
                that.manageScroll();
            });
            $(window).on('resize', function() {
                that.setMbVideoHeight();
            });
			// setTimeout(function () {
			// 	that.setBackgroundImages()
			// }, 1500);
            that.runScrollAnimation();

			this.equalHeight();

            this.enableTagButtonsForDataTags(this.identifyDataTags(['.probo']));
		},

		//--------------------------------------

        resetAnimationForIos: function (){
		    // if(this.isiOS()){
		        $('.teaser-content').removeClass('animated animated-up')
            // }
        },



    isiOS: function () {
        return [
                'iPad Simulator',
                'iPhone Simulator',
                'iPod Simulator',
                'iPad',
                'iPhone',
                'iPod'
            ].includes(navigator.platform)
            // iPad on iOS 13 detection
            || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
        },

		scrollToY: function (_y) {
			$('html, body').animate({scrollTop: _y}, '400');
            // console.log('doneScroll');
		},
		scrollToId: function (_id) {
			let offSet = $('.iconContainer').innerHeight();
			// console.log(offSet);
			this.scrollToY($('#' + _id).offset().top - (offSet + 50));
		},
        // manageScroll: function(){
        //     // console.log('inManageScroll');
        //     tempHash = window.location.hash;
        //     if(tempHash!=undefined&&tempHash!=''&&tempHash!=null&&tempHash!=0){
        //         tempPosition = $(tempHash).offset().top;
        //         newPosition = tempPosition-150;
        //         $('html, body').animate({
        //             scrollTop:newPosition
        //         },'slow');
        //     }
        // },


    equalHeight: function () {
			let addedClasses = "";
			let addedClassesCol = "";
			if (arguments[0] !== undefined) addedClasses = arguments[0];
			if (arguments[1] !== undefined) addedClassesCol = arguments[1];

			$('.sameHeightRow .sameHeightCol').css("height", "auto");
			setTimeout(function () {
				$('.sameHeightRow' + addedClasses).each(function () {
					let highestBox = 0;
					$('.sameHeightCol' + addedClassesCol, this).each(function () {
						if ($(this).height() > highestBox) {
							highestBox = $(this).height();
						}
					});
					$('.sameHeightCol' + addedClassesCol, this).height(highestBox);
				});

			}, 100);

		},

        manageScroll: function(){
            let mainMenu =  document.querySelector('#headerMain');
            let tempHash = window.location.hash;
            if(tempHash!=undefined&&tempHash!=''&&tempHash!=null&&tempHash!=0){
                if ($(mainMenu).hasClass("open")) {
                    $(mainMenu).removeClass("open");
                    document.body.style.position = '';
                    document.body.style.top = '';

                    // let scrollY = document.body.style.top;
                    // document.body.style.position = '';
                    // document.body.style.top = '';
                    // window.scrollTo(0, parseInt(scrollY || '0') * -1);
                }
                let that = this;
                setTimeout(function (){
                    let offSet = $('.iconContainer').innerHeight();

                    let tempPosition = $(tempHash).offset().top;
                    let newPosition = tempPosition - offSet;
                    // console.log(tempPosition);
                    // console.log(newPosition);

                    that.scrollToY(newPosition);
                },100);

                // $('html, body').animate({
                //     scrollTop:newPosition
                // },'slow');

            }

        },

        getURLPath: function(param){
		    let paramVal = false;
		    try {
                if($.QueryString[param]){
                    paramVal = $.QueryString[param];
                }
            }catch (e) {

            }
            return paramVal;
        },

        setMbVideoHeight: function(){
		    $('.v-std').each(function(){
		       $(this).css('height',(($(this).width() / 16) * 9));
		       // $(this).css('height',(($('.mb-background-video', this).width() / 16) * 7));
            });
		    $('.v-qua').each(function(){
		       $(this).css('height', $(this).width() );
		       // $(this).css('height',(($('.mb-background-video', this).width() / 16) * 7));
            });
		    $('.v-high').each(function(){
                $(this).css('height',(($(this).width() / 9) * 16));
		       // $(this).css('height',(($('.mb-background-video', this).width() / 16) * 7));
            });
		    $('.boxVideo').each(function(){
		       $(this).css('height',(($('.mb-background-video', this).width() / 16) * 8.75));
		       // $(this).css('height',(($('.mb-background-video', this).width() / 16) * 7));
            });
		    $('.mb-head').each(function(){
                // $('.mb-background-video', this).css('height',$('.mb-background-video', this).width());
                $('.mb-background-video', this).css('height',(($('.mb-background-video', this).width() / 16) * 12));
                // $('.mb-background-video', this).css('height',(($('.mb-background-video', this).width() / 16) * 8.75));
		       // $(this).css('height',(($('.mb-background-video', this).width() / 16) * 8.75));
		       // $(this).css('height',(($('.mb-background-video', this).width() / 16) * 7));
            });
		    // $('.vi-uf-mbVideo').each(function(){
		    //    $(this).css('height',(($('.mb-background-video', this).width() / 16) * 8.75));
		    //    // $(this).css('height',(($('.mb-background-video', this).width() / 16) * 7));
            // });
		    // $('.boxVideo').each(function(){
		    //    $(this).css('height',(($('.mb-background-video', this).width() / 16) * 8.75));
		    //    // $(this).css('height',(($('.mb-background-video', this).width() / 16) * 7));
            // });
        },



        showToTop: function () {
                let slimit = 100;
                let bScroll = Number($("body").scrollTop());
                let hScroll = Number($("html").scrollTop());
                if (hScroll < slimit && bScroll < slimit)
                    $(".toTopWrapper.showDialog").removeClass('showDialog');
                if (hScroll > slimit || bScroll > slimit)
                    $(".toTopWrapper").addClass('showDialog');
        },

        pageToTop() {
            $("html,body").animate({scrollTop: 0}, '500');
        },

		//---------------------------------------------------------
        checkVideoPlaySetup: function(){
            let that = this;
            $('.startVideoInView').each(function(){
               $('.mb-background-video', this).each(function(){
                   $('.innerVideo', this).each(function(){
                       let elem = this;
                       // if(that.isInViewport(elem)){
                       //     $(elem).play();
                       // }else{#
                       // console.log('pause');
                           elem.pause();
                       // $(elem).pause();
                       // }
                       $(elem).attr('controls',false);

                       if(that.isInViewport(elem)){
                           elem.play();
                           $(elem).attr('autoplay',true);
                       }

                       // $(elem).attr('autoplay',true);
                       $(window).scroll(function () {
                           if(that.isInViewport(elem)){
                               elem.play();
                               $(elem).attr('autoplay',true);
                           }
                    });
                   });
               });
           });
            $('.startVideoonClick').each(function(){
                let that = this;
                // if(that.isInViewport(elem)){
                //     elem.play();
                //     $(elem).attr('autoplay',false);
                // }
                $(this).css({'height':(($('.mb-background-video', this).width() / 16) * 10)});
                // $('.innerVideo', this).css({'display':'block'})
                $('.mb-background-video', this).each(function(){
                   $('.innerVideo', this).each(function(){
                       let elem = this;
                       $('.vidBtn', that).on('click', function(){
                           $(elem).parent().css({'z-index':'10', 'overflow-y': 'visible'});
                           $(elem).attr('loop',true);
                           $(elem).attr('controls',true);
                           elem.play();
                           $(this).hide();
                       });
                       // $(window).scroll(function () {
                       //     let result = that.isInViewport(elem);
                       //     // console.log(elem);
                       //     console.log(result);
                       // });
                   });
               });
           });
        },


		// Check if element is scrolled into view
		isInViewport: function (el) {
//             console.log(el);
//
//             // var top = el.offsetTop;
//             var top = $(el).offset().top;
//             var left = $(el).offset().left;
//             // var left = el.offsetLeft;
//             var width = el.offsetWidth;
//             var height = el.offsetHeight;
//
//             // while(el.offsetParent) {
//             //     el = el.offsetParent;
//             //     top += el.offsetTop;
//             //     left += el.offsetLeft;
//             // }
// console.log(top);
// console.log(left);
// console.log(height);
// console.log(width);
// console.log(window.pageYOffset);
// console.log(window.innerHeight);
// console.log(window.pageXOffset);
// console.log(window.innerWidth);
//             return (
//                 top < (window.pageYOffset + window.innerHeight) &&
//                 left < (window.pageXOffset + window.innerWidth) &&
//                 (top + height) > window.pageYOffset &&
//                 (left + width) > window.pageXOffset
//             );


            var top = el.offsetTop;
            var left = el.offsetLeft;
            var width = el.offsetWidth;
            var height = el.offsetHeight;

            while(el.offsetParent) {
                el = el.offsetParent;
                top += el.offsetTop;
                left += el.offsetLeft;
            }

            return (
                top < (window.pageYOffset + window.innerHeight) &&
                left < (window.pageXOffset + window.innerWidth) &&
                (top + height) > window.pageYOffset &&
                (left + width) > window.pageXOffset
            );



            // const rect = elem.getBoundingClientRect();
            // return (
            //     rect.top >= 0 &&
            //     rect.left >= 0 &&
            //     rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            //     rect.right <= (window.innerWidth || document.documentElement.clientWidth)
            //
            // );

            // let docViewTop = $(window).scrollTop();
			// let docViewBottom = docViewTop + $(window).height();
            //
			// let elemTop = $(elem).offset().top;
			// let elemBottom = elemTop + $(elem).height();
            //
			// //return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
			// let topInView = ((elemTop <= docViewBottom) && (elemTop >= docViewTop));
			// let bottomInView = ((elemBottom <= docViewBottom) && (elemBottom >= docViewTop));
			// return topInView || bottomInView;
		},

        // setBurger: function () {
        //
        //     // $('#hamburgerIcon').on('click', function(_event){
        //     //     $(this).toggleClass('showMenue').parent().parent().find('.linkElementsWrapper').toggleClass('showMenue');
        //     //     $(this).parent().parent().parent().parent().toggleClass('menueOpen');
        //     // });
        //     //
        //     // $('.linkElements a').on('click', function(_event){
        //     //     $('#hamburgerIcon').click();
        //     // });
        //     $('#hamburgerIcon').on('click', function(_event){
        //         $(this).toggleClass('showMenue').parent().parent().find('.linkElementsWrapper').toggleClass('showMenue');
        //         $(this).parent().parent().parent().parent().toggleClass('menueOpen');
        //     })
        //
        // },

        bindBurger: function() {
            let that = this;
            let burger = document.querySelector('#hamburgerIcon');
            let mainMenu =  document.querySelector('#headerMain');
            burger.addEventListener("click", ()=>{
                that.toggleMenu(mainMenu)
            });
        },


        setMenueSlug: function() {
            // let _base = this.baseUrl;
            let _url = window.location.href;
            // let _start = _base.length - 1;
            // let addUrl = _url.substring(_start);
            // console.log(_base);
            // console.log(_url);
            // console.log(_start);
            // console.log(addUrl);
            $('#headerMain .confClass-menue-crawler a').each(function(){
                // console.log($(this).prop('href'));
                if($(this).prop('href') === _url){
                    $(this).addClass('activeSlug');
                }
            });


        },

        setMenueListBinding: function() {
            var isTouch = false;
            if(window.matchMedia("(pointer: coarse)").matches) {
                isTouch = true;
                // alert('Touch');
            }

            // isTouch =  ("ontouchstart" in window) || (navigator.maxTouchPoints > 0) || window.navigator.msMaxTouchPoints > 0 ;
            if( isTouch ) {
                $('.level-1').parent().addClass('touchDevice');
                let that = this;
                $('.level-1').each(function () {
                    if ($(this).find('.ul-lev-2').length > 0) {
                        $(this).addClass('hasSubMenue untapped');
                    }
                });
                $('.menueItem.level-1').click(function () {
                    $('.level-1').each(function () {
                        if ($(this).find('.ul-lev-2').length > 0) {
                            $(this).addClass('untapped');
                        }
                    });
                    $(this).parent().removeClass('untapped');
                    $('.ul-lev-2,.ul-lev-3').removeClass('active');
                    $(this).parent().find('.ul-lev-2').addClass('active');

                    $('.menueImage').removeClass('active');
                    let imageClass = $(this).data('image');
                    $('.' + imageClass).addClass('active');
                    that.setMenueListSecondBinding();
                });

            }else{
                let that = this;
                $('.level-1').each(function () {
                    if ($(this).find('.ul-lev-2').length > 0) {
                        $(this).addClass('hasSubMenue');
                    }
                });
                $('.menueItem.level-1').mouseover(function () {
                    $('.ul-lev-2,.ul-lev-3').removeClass('active');
                    $(this).parent().find('.ul-lev-2').addClass('active');
                    $('.menueImage').removeClass('active');
                    let imageClass = $(this).data('image');
                    $('.' + imageClass).addClass('active');
                    that.setMenueListSecondBinding();
                });
            }
                // console.log('initFirstBinding');
        },


        setMenueListSecondBinding: function() {
            var isTouch = false;
            if(window.matchMedia("(pointer: coarse)").matches) {
                isTouch = true;
            }

            // isTouch =  ("ontouchstart" in window) || (navigator.maxTouchPoints > 0) || window.navigator.msMaxTouchPoints > 0 ;
            if( isTouch ) {

                // console.log('initSeconBinding');
                $('.level-2').each(function () {
                    if ($(this).find('.ul-lev-3').length > 0) {
                        $(this).addClass('hasSubMenue untapped');
                    }
                });

                $('.level-2').click(function () {
                    if ($(this).find('.ul-lev-3').length > 0) {
                        $('.level-2').each(function () {
                            if ($(this).find('.ul-lev-3').length > 0) {
                                $(this).addClass('untapped');
                            }
                        });
                        $(this).removeClass('untapped');
                        $('.ul-lev-3').removeClass('active');
                        $(this).find('.ul-lev-3').addClass('active');
                    }
                });
            }else{
                // console.log('initSeconBinding');
                $('.level-2').each(function () {
                    if ($(this).find('.ul-lev-3').length > 0) {
                        $(this).addClass('hasSubMenue');
                    }
                });

                $('.level-2').mouseover(function () {
                    if ($(this).find('.ul-lev-3').length > 0) {
                        // $(this).addClass('hasSubMenue');
                        $('.ul-lev-3').removeClass('active');
                        $(this).find('.ul-lev-3').addClass('active');
                    }
                });
            }
        },


        bindContactButton: function() {
            let that = this;
            let cbtn = document.querySelectorAll('.btnContact');
            let mainMenu =  document.querySelector('#headerMain');
            if (typeof(cbtn) != 'undefined' && cbtn != null){
                cbtn.forEach((item)=>{
                    item.addEventListener("click", ()=>{
                        that.toggleMenu(mainMenu)
                    });
                });
            }
        },

        showCrInfo: function(_elem){
            $(_elem).parent().click(function(e) {
                e.preventDefault();
            });
            // let curhref = window.location.href;
            $(_elem).find('p').toggleClass('showInfo');
            setTimeout(function (){
                $(_elem).parent().unbind('click');
            },1000);
        },


        toggleMenu: function (menu = document.querySelector('#headerMain')) {



            // // let slimit=100;
            // // let bScroll=Number($("body").scrollTop());
            // // let hScroll=Number($("html").scrollTop());
            // // if(hScroll<slimit && bScroll<slimit)
            // //     $('#header').removeClass('headerStick');
            // // if(hScroll>slimit || bScroll>slimit)
            // //     $('#header').addClass('headerStick');
            //
            //
            // let slimit=100;
            // let bScroll=Number($("body").scrollTop());
            // let hScroll=Number($("html").scrollTop());
            // if(hScroll<slimit && bScroll<slimit)
            //     $('#header').removeClass('headerStick');
            // if(hScroll>slimit || bScroll>slimit)
            //     $('#header').addClass('headerStick');

            if ($(menu).hasClass("open")) {
                $(menu).removeClass("open");

                let scrollY = document.body.style.top;
                document.body.style.position = '';
                document.body.style.top = '';
                window.scrollTo(0, parseInt(scrollY || '0') * -1);
            } else {
                $(menu).addClass("open");

                // When the modal is shown, we want a fixed body
                document.body.style.top = -1 * window.scrollY+"px";
                document.body.style.position = 'fixed';
            }

        },

        toggleMenue: function (menu) {


            // let slimit=100;
            // let bScroll=Number($("body").scrollTop());
            // let hScroll=Number($("html").scrollTop());
            // if(hScroll<slimit && bScroll<slimit)
            //     $('#header').removeClass('headerStick');
            // if(hScroll>slimit || bScroll>slimit)
            //     $('#header').addClass('headerStick');


            let slimit=100;
            let bScroll=Number($("body").scrollTop());
            let hScroll=Number($("html").scrollTop());
            if(hScroll<slimit && bScroll<slimit)
                $('#headerMain').removeClass('headerStick');
            if(hScroll>slimit || bScroll>slimit)
                $('#headerMain').addClass('headerStick');


        },



        setYoutubeBox: function () {
			$('.vi-uf-blogListItem .vi-uf-blogBox').each(function () {
				if ($('.vi-uf-blogBoxVideo', this).length > 0) {
					let srcVal = $('.vi-uf-blogBoxVideo', this).data('src-value');
					let ytSrcClean;
					if (srcVal.indexOf('youtu.be') !== -1) {
						let ytSrcFind = srcVal.lastIndexOf('/');
						ytSrcClean = srcVal.slice(ytSrcFind);
					} else {
						let ytSrcFind = srcVal.lastIndexOf('=') + 1;
						ytSrcClean = '/' + srcVal.slice(ytSrcFind);
					}
					$('.vi-uf-blogBoxImage', this).hide();
					$('.vi-uf-blogBoxVideo', this).show().find('iframe').attr('src', 'https://www.youtube.com/embed' + ytSrcClean + '?rel=0&amp;controls=1&amp;showinfo=0&amp;autoplay=0');  //.attr('autoplay','1').get(0).click();
				}
			});
			$('.mubo-b-2').each(function () {
				if ($('.videoLinkEl', this).length > 0) {
					let srcVal = $('.videoLinkEl', this).data('src-value');
					let ytSrcFind;
					if (srcVal.indexOf('youtu.be') !== -1) {
						ytSrcFind = srcVal.lastIndexOf('/');
					} else {
						ytSrcFind = srcVal.lastIndexOf('=');
					}
					let ytSrcClean = srcVal.slice(ytSrcFind);
					$('.videoLinkEl', this).find('iframe').attr('src', 'https://www.youtube.com/embed' + ytSrcClean + '?rel=0&amp;controls=1&amp;showinfo=0&amp;autoplay=0');  //.attr('autoplay','1').get(0).click();
				}
			});
		},

        enableAccordion: function(_el){

            //multibox
            $('.vi-uf-accordionBoxInnerContent').each(function () {
                    $('.vi-uf-accordionBoxElement', this).accordion({
                        animate: 300,
                        header: 'h3',
                        collapsible: true,
                        heightStyle: 'content',
                        active: false
                    });
            });



		},

		removeOverlay: function(_el){
			$(_el).hide().parent().find('video').get(0).play();
		},

        slideLoadedSingle: function(){
                let _vid = $('.innerVideo');
                if(_vid.length > 0){
                    var mediaVideo = _vid.get(0);
                    // setTimeout(function(){
                        _vid.parent().css('z-index','-1');
                        _vid.parent().css('display','flex');
                        _vid.parent().parent().find('.mubo-bg').remove();
                        mediaVideo.play();
                    // },1500);


            }


		},
        showMenu: function() {
            //$("#menuContent").show();
            $("body").addClass("menu-open");
        },

        closeMenu: function() {
            //$("#menuContent").hide();
            $("body").removeClass("menu-open");
        },

        //------------------------------------------------------------

        // Check if element is scrolled into view
        isScrolledIntoView: function(elem) {
            let docViewTop = $(window).scrollTop();
            let docViewBottom = docViewTop + $(window).height();

            let elemTop = $(elem).offset().top;
            let elemBottom = elemTop + $(elem).height();

            //return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
            let topInView = ((elemTop <= docViewBottom) && (elemTop >= docViewTop));
            let bottomInView = ((elemBottom <= docViewBottom) && (elemBottom >= docViewTop));
            return topInView || bottomInView;
        },

        //Trigger Animation
        //animateCss($(".personBox"), "shakeX");
        animateCss: function(el, animationName) {

            let animationPrefix = "";//animate__
            //als Promise benachrichtigen, wenn fertig
            return new Promise((resolve, reject) => {
                //gleichzeitig auf Ende horchen und aufräumen
                el.addClass(animationPrefix + 'animated ' + animationPrefix + animationName).one('animationend', function () {
                    el.removeClass(animationPrefix + 'animated ' + animationName);
                    //fertig
                    resolve();
                });
            });
        },

        //scroll-basierte Animationen triggern
        runScrollAnimation: function() {
            let that = this;
            $('.scroll-animations .animated').each(function () {
                if (that.isScrolledIntoView(this) === true) {

                    let thisEl = $(this);

                    if (thisEl.hasClass("animated-left")) {
                        thisEl.addClass('fadeInLeft ');
                    }
                    if (thisEl.hasClass("animated-up")) {
                        thisEl.addClass('fadeInUp ');
                    }
                    if (thisEl.hasClass("animated-right")) {
                        thisEl.addClass('fadeInRight');
                    }
                    if (thisEl.hasClass("animated-fadeIn")) {
                        thisEl.addClass('fadeIn');
                    }
                    if (thisEl.hasClass("animated-zoom")) {
                        thisEl.addClass('zoomIn');
                        setTimeout(function () {
                            thisEl.removeClass('animated-zoom zoomIn');
                        }, 1000);
                    }
                }
                else{

                    //Reset oben /NOT: und unten
                    let scrollTop = $(window).scrollTop();
                    let scrollHeight = $(document).height();
                    let scrollPosition = $(window).height() + $(window).scrollTop();
                    if ((scrollTop === 0) /*|| ((scrollHeight - scrollPosition) / scrollHeight === 0)*/) {
                        $(this).removeClass('fadeInLeft fadeInUp fadeInRight fadeIn');
                    }
                }
            });
        }




    };

	//------------------------------------

	//gemeinsam verfügbar machen
	if (typeof (cologic) === 'undefined')
		window.cologic = {};
	$.extend(cologic, cologicViewService);
}());